module.exports = __webpack_public_path__ + "static/media/where-in-the-world.e5937c02.png";